import { SVGProps } from 'react'

export const GBPInCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM7.99023 4.66699C7.59673 4.66699 7.2459 4.74786 6.93848 4.91016C6.63737 5.06617 6.40062 5.29076 6.22852 5.58398C6.06256 5.87103 5.97955 6.21139 5.97949 6.60449C5.97949 6.85418 6.00452 7.08562 6.05371 7.29785C6.10269 7.48017 6.1602 7.65462 6.22363 7.82227H5.38965V8.46777H6.43848C6.48839 8.64059 6.51465 8.82201 6.51465 9.01172C6.51461 9.27993 6.48332 9.51424 6.42188 9.71387C6.3604 9.90719 6.27199 10.0884 6.15527 10.2568C6.0446 10.4191 5.91152 10.5844 5.75781 10.7529V11.333H10.0557V10.5654H6.72656C6.9601 10.3346 7.12622 10.0882 7.22461 9.82617C7.32912 9.56402 7.38183 9.28906 7.38184 9.00195C7.38184 8.81895 7.3591 8.64092 7.31543 8.46777H8.87598V7.82227H7.11426C7.04663 7.62876 6.98502 7.43472 6.92969 7.24121C6.88055 7.0478 6.85547 6.85102 6.85547 6.65137C6.85551 6.37061 6.90821 6.14249 7.0127 5.96777C7.11719 5.78694 7.2557 5.65629 7.42773 5.5752C7.60593 5.48787 7.79626 5.4434 7.99902 5.44336C8.37408 5.44336 8.66331 5.55653 8.86621 5.78125C9.06901 6.00594 9.17716 6.28703 9.18945 6.62402H10.0371C10.0187 6.26822 9.93037 5.9428 9.77051 5.64941C9.6168 5.34986 9.39175 5.11323 9.09668 4.93848C8.80773 4.75747 8.43902 4.66701 7.99023 4.66699Z'
        fill='currentColor'
      />
    </svg>
  )
}
